import {useQuery, useMutation, gql} from 'admin/lib/apollo'

export const GET_ADMIN = gql`
  query GetAdmin {
    admin {
      id
      email
      preferences
    }
  }
`

export const UPDATE_ADMIN = gql`
  mutation UpdateAdmin($preferences: JSON) {
    admin(preferences: $preferences) {
      id
      email
      preferences
    }
  }
`

export default () => {
  const {data: {admin = {}} = {}, error: getError} = useQuery(GET_ADMIN)
  const [update, {error: updateError}] = useMutation(UPDATE_ADMIN)

  return {
    admin,
    errors: getError || updateError || {},
    update
  }
}
